import { APIUrls } from "../../Constants/ApiUrls";
import { ISensor } from "../../Models/ISensor";
import { ISentinel } from "../../Models/ISentinel";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const SentinelController = {
  GetSentinelsPoll: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINELS_URL;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetSentinels: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINELS_URL;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  // fresh: dopo una modifica si rilegge dal server, senza la copia in cache
  GetSentinelsAll: async (callback?: (response: IAPIResponse) => void, fresh = false) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINELS_ALL_URL;
    request.allowApiCache = !fresh;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  ValidateCamSession: async (
    targetUrl: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url =
      APIUrls.SENTINELS.SENTINELS_VALIDATE_CAM + "?url=" + targetUrl;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetSentinel: async (
    sentinelId: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINEL_BY_ID_URL.replace(
      ":sentinelId",
      sentinelId
    );
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  AddSentinel: async (
    deviceType?: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINELS_URL;
    request.method = "POST";
    request.payload = { deviceType: deviceType || "Letto" };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  UpdateSentinel: async (
    sentinel: ISentinel,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINEL_BY_ID_URL.replace(
      ":sentinelId",
      sentinel.id.toString()
    );
    request.method = "PUT";
    request.payload = sentinel;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetLedStatus: async (
    sentinelId: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINEL_LED_STATUS_URL.replace(
      ":sentinelId",
      sentinelId
    );
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  UpdateLedStatus: async (
    sentinelId: string,
    enabled: boolean,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url =
      APIUrls.SENTINELS.SENTINEL_LED_STATUS_URL.replace(
        ":sentinelId",
        sentinelId
      ) + (enabled ? "/on" : "/off");
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  UpdateSensor: async (
    sentinelId: string,
    sensor: ISensor,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINEL_SENSOR_UPDATE_URL.replace(
      ":sentinelId",
      sentinelId
    ).replace(":sensorId", sensor.id.toString());
    request.method = "PUT";
    request.payload = sensor;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetRealTimeSensorValues: async (
    sentinelId: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENTINELS.SENTINEL_SENSOR_VALUES_URL.replace(
      ":sentinelId",
      sentinelId
    );
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  LogicalDeleteSentinel: async (
    sentinelId: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = `${APIUrls.SENTINELS.SENTINEL_LOGICAL_DELETE}?sentinelId=${sentinelId}`;
    request.method = "POST";
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  LogicalReenableSentinel: async (
    sentinelId: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = `${APIUrls.SENTINELS.SENTINEL_LOGICAL_RESTORE}?sentinelId=${sentinelId}`;
    request.method = "POST";
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default SentinelController;
